import { useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { BaseSuspenseQueryOpts } from '../baseTypes';
import { getCollaborativeStateDetailsByIds, updateCollaborativeStateDetails, UpdateCollaborativeStateDetailsParams } from '@uplift/api';


const keys = {
  statesDetails: () => [ 'collaboration', 'state' ],
};


export const useCollaborativeStatesDetailsQuery = (opts?: BaseSuspenseQueryOpts) => {
  return useSuspenseQuery({
    queryKey: keys.statesDetails(),
    queryFn: async () => {
      const response = await getCollaborativeStateDetailsByIds();

      return response.data;
    },
    ...opts,
  });
};


export const useCollaborativeStateDetailsQuery = (stateId?: string, opts?: BaseSuspenseQueryOpts) => {
  return useSuspenseQuery({
    queryKey: keys.statesDetails(),
    queryFn: async () => {
      const response = await getCollaborativeStateDetailsByIds();

      return response.data;
    },
    select: (response) => response.find(s => s.stateId === stateId) ?? null,
    ...opts,
  });
};


export const useUpdateCollaborativeStateDetailsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ stateId, ...params }: {stateId: string} & UpdateCollaborativeStateDetailsParams) => {
      await updateCollaborativeStateDetails(stateId, params);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: keys.statesDetails() });
    }
  });
};
